import I18n from 'I18n';
import { getPrivacyPolicyLabel } from './getPrivacyPolicyLabel';
export const getGdprSubmissionText = () => {
  const privacyPolicyLabel = getPrivacyPolicyLabel();
  return I18n.text(privacyPolicyLabel, {
    termsOfServiceLink: 'http://www.hubspot.com/terms-of-service',
    privacyPolicyLink: 'https://legal.hubspot.com/privacy-policy'
  });
};